import dayjs from 'dayjs'

export function filterCertificationTermsList(certifications, filters) {
  const {
    dayFilterFrom,
    dayFilterTo,
    kindFilter,
    departmentFilter,
    examinerFilter,
    localizationFilter,
    statusFilter,
  } = filters

  let list = Array.isArray(certifications) ? [...certifications] : []

  if (dayFilterFrom || dayFilterTo) {
    list = list.filter(item => {
      const date = dayjs(item.date).startOf('day')
      if (dayFilterFrom && date.isBefore(dayjs(dayFilterFrom).startOf('day'))) {
        return false
      }
      if (dayFilterTo && date.isAfter(dayjs(dayFilterTo).startOf('day'))) {
        return false
      }
      return true
    })
  }

  if (kindFilter) {
    list = list.filter(item => item.kind === kindFilter)
  }

  if (departmentFilter) {
    list = list.filter(item => (item.departments || []).includes(departmentFilter))
  }

  if (examinerFilter) {
    list = list.filter(item => item.examiner && item.examiner['@id'] === examinerFilter)
  }

  if (localizationFilter) {
    const q = localizationFilter.toLowerCase()
    list = list.filter(item => (item.localization || '').toLowerCase().includes(q))
  }

  if (statusFilter) {
    list = list.filter(item => item.status === statusFilter)
  }

  return list.sort((a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf())
}

export function canDeleteCertificationTerm(takenSlotsCount) {
  return takenSlotsCount <= 0
}
